import { render, staticRenderFns } from "./payment-component.vue?vue&type=template&id=20d36460&"
import script from "./payment-component.vue?vue&type=script&lang=js&"
export * from "./payment-component.vue?vue&type=script&lang=js&"
import style0 from "./payment-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports